export default __webpack_public_path__ + "static/fertilesummerhome1-5f20a6c1899fea6aefb99a47be72c962.png";